import { useEffect } from 'react';
import { preloadImage } from '../utils/imageCache';

const useLogoPreloader = (homepageData) => {
  useEffect(() => {
    const logos = [
      homepageData?.level_62_logo_white?.url || homepageData?.level_62_logo_white,
      homepageData?.level_62_logo_black?.url || homepageData?.level_62_logo_black,
      homepageData?.level_62_logo_simple_white?.url || homepageData?.level_62_logo_simple_white,
      homepageData?.level_62_logo_simple_black?.url || homepageData?.level_62_logo_simple_black,
      homepageData?.spaceforce_icon_white?.url || homepageData?.spaceforce_icon_white,
      homepageData?.spaceforce_icon_black?.url || homepageData?.spaceforce_icon_black,
      homepageData?.level_62_icon_white?.url || homepageData?.level_62_icon_white,
      homepageData?.level_62_icon_black?.url || homepageData?.level_62_icon_black
    ].filter(Boolean);

    logos.forEach((logo) => {
      preloadImage(logo);
    });
  }, [homepageData]);
};

export default useLogoPreloader;
